<template>
  <div class="mt-1 flex items-center py-2">
    <KikIcon
      icon="preferredFilial"
      size="sm"
      class="place-content-center place-items-center place-self-center fill-secondary"
    />
    <NuxtLink
      :to="$t('/preferredfilial')"
      class="flex items-center border-r border-neutral-900 px-2 text-[12px] leading-[12px] last:border-0 desktop:text-[13px] desktop:leading-[13px]"
      @click.prevent="saveActiveRoute()"
    >
      <div
        v-if="!preferredFilialCookie"
        class="flex text-sm underline"
      >
        {{ $t('check filial availability') }}
      </div>
      <div
        v-else
        class="flex"
      >
        <div class="text-sm">
          <p class="inline-block underline">
            {{ $t('my filial') }}
          </p> | <b>{{ preferredFilialCity }}</b> {{ showStock.text }}
        </div>
      </div></NuxtLink>
  </div>
  <div
    v-show="preferredFilialCookie"
    class="mt-0.5 flex h-1 w-0 transition-all duration-500 ease-in"
    :class="showStock.style"
  />
</template>

<script lang="ts" setup>
import { useLastVisitedPage } from '~/composables/custom/useLastVisitedPage';

interface StockInFilial {
  sku: string;
  stock: number;
}
const route = useRoute();

const { addPage } = useLastVisitedPage();

const { $i18n, $domain } = useNuxtApp();

interface Props {
  preferredFilialCookie: any;
  stockInFilial: StockInFilial[] | undefined;
  sku: string;
}

const { preferredFilialCookie, stockInFilial, sku } = defineProps<Props>();
const preferredFilialCity = computed<string>(() => preferredFilialCookie?.city);
const showStock = computed(() => {
  const stockForSku = stockInFilial?.find(stock => sku === stock.sku)?.stock;
  if (!stockForSku) {
    return { text: '', style: '' };
  }

  if (stockForSku >= 1 && stockForSku < $domain.onlyLessAvailableTreshold) {
    return { text: `(${$i18n.t('only less available')})`, style: 'bg-positive-500 !w-full' };
  }
  else if (stockForSku >= 3) {
    return { text: `(${$i18n.t('available')})`, style: 'bg-positive-500 !w-full' };
  }
  else {
    return { text: `(${$i18n.t('out of stock')})`, style: 'bg-neutral-200 !w-full' };
  }
});
const saveActiveRoute = () => {
  addPage(route.fullPath);
};
</script>
